import {
  CHANNEL_MODALITY_ICON_PATHS,
  channelKeyToModality,
} from 'components/@home/@settings/Tabs/Agents/instructionEditor/channelModalityIcons';
import { number, oneOf } from 'prop-types';
import React from 'react';

/** Stroke-outline channel glyph — same paths as InstructionEditor scope chips. */
const ChannelModalityIcon = ({ modality, size = 13, className, style, ...rest }) => {
  const key = channelKeyToModality(modality);
  return (
    <svg
      viewBox="0 0 24 24"
      width={size}
      height={size}
      aria-hidden="true"
      className={className}
      style={{ display: 'block', flexShrink: 0, ...style }}
      {...rest}
    >
      <path
        d={CHANNEL_MODALITY_ICON_PATHS[key]}
        fill="none"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

ChannelModalityIcon.propTypes = {
  modality: oneOf(['text', 'voice', 'chat']).isRequired,
  size: number,
};

export default ChannelModalityIcon;
